import type { CardRendererProps } from './registry.js';
import { CardFrame } from './CardFrame.js';

/**
 * Fallback for a card type no renderer is registered for — either an older
 * client than the engine that produced it, or a module that is not enabled for
 * this organization.
 */
export function UnknownCard({ card }: CardRendererProps) {
  return (
    <CardFrame eyebrow={card.type} title="Unsupported card">
      <p className="text-[12.5px] text-muted">
        This card is not available in the current interface. Ask in the conversation and I will answer in text.
      </p>
    </CardFrame>
  );
}
